import { Card, message, Pagination, Space, Tag, Tooltip } from "antd";
import Button from "../../../components/common/button";
import View from "../../../assets/icons/view.svg";
import Trash from "../../../assets/icons/trash.svg";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { getPromoCodeList, deletePromoCode } from "../../../api/user";
import { Link } from "react-router-dom";
import Back from "../../../assets/icons/back.svg";
import PromoCodeForm from "../../../components/promoCode/promoCodeForm";
import { resetText } from "../../../store/slices/textSlice";
import DeleteMemberModal from "../../../components/common/modalMember";
import Table from "../../../components/common/table";
import moment from "moment";
import colors from "../../../share/constants/constants";
import UserListModal from "./usersModal";

const PromoCode = () => {
  const dispatch = useDispatch();
  const [addType, setAddType] = useState(false);
  const [editPromoCode, setEditPromoCode] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPromoCodeLoading, setIsPromoCodeLoading] = useState(false);
  const [promoCodes, setPromoCodes] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [userModal, setUsersModal] = useState(false);
  const [usersList, setUsersList] = useState([]);

  const text = useSelector((state) => state?.text?.value);

  const userCounts = (record) => {
    const displayUsers = record?.assignedUsers
      .slice(0, 2)
      .map((user) => `${user?.user?.firstName} ${user?.user?.lastName}`)
      .join(", ");

    const remainingUsersCount = record?.assignedUsers?.length - 2;

    const usersText =
      remainingUsersCount > 0 ? (
        <>
          {displayUsers}{" "}
          <Tag
            className="cursor-pointer"
            onClick={() => handleUserModal(record?.assignedUsers)}
          >
            +{remainingUsersCount} more
          </Tag>
        </>
      ) : (
        <span
          className="cursor-pointer"
          onClick={() => handleUserModal(record?.assignedUsers)}
        >
          {displayUsers}
        </span>
      );
    return usersText;
  };

  const itemRender = (page, type, originalElement) => {
    if (type === "page") {
      return (
        <div
          className={`rounded ${
            currentPage === page
              ? "bg-primaryPurple text-white"
              : "bg-white text-black"
          }`}
          style={{ cursor: "pointer" }}
        >
          {page}
        </div>
      );
    }
    return originalElement;
  };

  const columns = [
    {
      title: "Promo Code",
      key: "promoCode",
      dataIndex: "promoCode",
    },
    {
      title: "Promo Code Type",
      key: "promoType",
      dataIndex: "promoType",
      render: (text, record) => (
        <>
          <Space>
            {record?.promoType === "SERVICE" && (
              <Tag color="magenta">Service</Tag>
            )}
            {record?.promoType === "VARIANT" && (
              <Tag color="magenta">Variant</Tag>
            )}
            {record?.promoType === "USER" && <Tag color="green">User</Tag>}
            {record?.promoType === "REWARD" && (
              <Tag color="geekblue">Reward</Tag>
            )}
            {record?.promoType === "CATEGORY" && (
              <Tag color="cyan">Category</Tag>
            )}
            {record?.promoType === "GLOBAL" && (
              <Tag color="purple">For All Users (Global)</Tag>
            )}
          </Space>
        </>
      ),
    },
    {
      title: "Discount Amount ($)",
      key: "discountAmount",
      dataIndex: "discountAmount",
      render: (text, record) => <>${record.discountAmount}</>,
    },
    {
      title: "Start Date",
      key: "startDate",
      dataIndex: "startDate",
      render: (text, record) => (
        <>{moment(record?.startDate).format("MM/DD/YYYY hh:mm A")}</>
      ),
    },
    {
      title: "End Date",
      key: "expiryDate",
      dataIndex: "expiryDate",
      render: (text, record) => (
        <>{moment(record?.expiryDate).format("MM/DD/YYYY hh:mm A")}</>
      ),
    },
    {
      title: "Service Name",
      key: "serviceId",
      dataIndex: "serviceId",
      render: (text, record) => (
        <>
          {record?.serviceId
            ? record?.serviceId
                .map(
                  (service) =>
                    `${service?.variantTitle ?? service.serviceName} (${
                      service.businessId.businessName
                    })`
                )
                .join(", ")
            : "-"}
        </>
      ),
    },
    {
      title: "Users",
      key: "assignedUsers",
      dataIndex: "assignedUsers",
      render: (text, record) => (
        <>{record?.assignedUsers ? userCounts(record) : "-"}</>
      ),
    },
    {
      title: "Category",
      key: "categoryId",
      dataIndex: "categoryId",
      render: (text, record) => (
        <>
          {record?.categoryId
            ? record?.categoryId.map((cat) => cat?.name).join(", ")
            : "-"}
        </>
      ),
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
      render: (text, record) => {
        return new Date(record?.startDate) <= new Date() &&
          new Date() <= new Date(record?.expiryDate) &&
          !record?.isDeleted ? (
          <Tag color="success">Active</Tag>
        ) : (
          <Tag color="error">Inactive</Tag>
        );
      },
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <div className="flex space-x-1">
          <Tooltip placement="top" title={"View"} key={`view_${record?._id}`}>
            <Link to={`/main/promo-code/${record?._id}`}>
              <div className="w-4 m-auto grid justify-center h-4 pt-1 rounded-full bg-lightLavender cursor-pointer">
                <img src={View} alt="View" />
              </div>
            </Link>
          </Tooltip>
          <Tooltip
            placement="top"
            title={"Disable Promocode?"}
            key={`dis_${record?._id}`}
          >
            <div
              onClick={() => showModal(record?._id)}
              className="w-4 m-auto grid justify-center h-4 pt-1 rounded-full bg-lightCrimson cursor-pointer"
            >
              <img src={Trash} alt="Disable promo code" />
            </div>
          </Tooltip>
        </div>
      ),
    },
  ];

  const onHandleBack = () => {
    setAddType(false);
  };

  const handleAddBusiness = () => {
    setAddType(true);
    setEditPromoCode(null);
  };
  const handleEditBusiness = (values) => {
    setAddType(true);
    setEditPromoCode(values);
  };

  const showModal = (id) => {
    setIsModalOpen(true);
    setSelectedId(id);
  };

  useEffect(() => {
    dispatch(resetText());
  }, []);

  useEffect(() => {
    getPromoCodes(currentPage, pageSize, text);
  }, [currentPage, pageSize, text]);

  const getPromoCodes = async (currentPage, pageSize, text) => {
    setIsPromoCodeLoading(true);
    try {
      const res = await getPromoCodeList(currentPage, pageSize, text);
      if (res) {
        // Filter out promo codes where promoType is 'REWARD'
        const filteredPromoCodes = res?.items?.filter(
          (promoCode) => promoCode.promoType !== "REWARD"
        );
        res.items = filteredPromoCodes;
        setPromoCodes(res);
      }
    } catch (error) {
      console.error("Failed to fetch promo codes", error);
    } finally {
      setIsPromoCodeLoading(false);
    }
  };

  const onDeleteHandler = async () => {
    setIsModalOpen(false);
    const res = await deletePromoCode(selectedId);
    if (res) {
      message.success("Promo code has been disabled successfully");
      getPromoCodes(currentPage, pageSize, text);
    }
  };

  const handleUserModal = (users) => {
    setUsersModal(true);
    setUsersList(users);
  };

  return (
    <>
      <div>
        <div className="flex justify-between">
          <div className="flex pt-3 pl-3">
            <Link to="/main/promo-code" onClick={onHandleBack}>
              <div className="flex items-center">
                {addType && <img src={Back} alt="Edit Icon" className="mr-1" />}

                <span className="text-lg font-bold text-black ml-1">
                  Promo Codes
                </span>
              </div>
            </Link>
          </div>
          {!addType && (
            <div className="mt-2 mr-2">
              <Link to={`/main/promo-code/new`}>
                <Button
                  title="Add New Promo"
                  className="w-18 h-3.8"
                  color={colors.primaryPurple}
                  borderRadius={5}
                  onClick={() => {}}
                />
              </Link>
            </div>
          )}
        </div>
        <div>
          <div>
            <div className="flex items-start justify-start pt-0">
              <Table
                columns={columns}
                data={promoCodes?.items}
                loading={isPromoCodeLoading}
              />
            </div>
          </div>
          <div className="flex justify-center items-center pagination-container mb-2">
            <Pagination
              current={currentPage}
              total={promoCodes?.totalItems}
              pageSize={pageSize}
              onShowSizeChange={(current, size) => setPageSize(size)}
              pageSizeOptions={[10, 20, 30, 40]}
              onChange={(e) => {
                setCurrentPage(e);
              }}
              itemRender={itemRender}
              responsive={true}
              className="custom-pagination"
            />
          </div>
        </div>

        {isModalOpen && (
          <DeleteMemberModal
            title="Disable Promo Code"
            text="Are you sure you want to disable this promo code?"
            onCancel={() => setIsModalOpen(false)}
            onOk={onDeleteHandler}
          />
        )}

        <UserListModal
          open={userModal}
          users={usersList}
          handleOk={() => setUsersModal(false)}
        />
      </div>
    </>
  );
};

export default PromoCode;
